import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Inject, Input, Output, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i5 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepStatusUpdate } from 'visa-store';
import * as i3 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i1$1 from 'step-status-update-payload-service';
import * as i4 from 'ngx-toastr';
import * as i6 from 'base-document-checklist-library';
import * as i7 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';
import * as i8 from '@angular/material/icon';
import * as i9 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i10 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i11 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i12 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i13 from 'primeng/inputtextarea';
import { InputTextareaModule } from 'primeng/inputtextarea';
import * as i14 from 'primeng/inputtext';
import * as i15 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i16 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { PrimengLibraryModule } from 'primeng-library';

class CustomQuestionnaireService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.selectedFamilyIdSubject = new Subject();
    }
    saveQuestionList(beneficiaryId, companyId, familyId, payload) {
        let dynamicUrl;
        if (familyId) {
            dynamicUrl = `/saveCustomSectionsForBeneficiary/${beneficiaryId}/${companyId}?familyId=${familyId}`;
        }
        else {
            dynamicUrl = `/saveCustomSectionsForBeneficiary/${beneficiaryId}/${companyId}`;
        }
        return this.httpClient.post(dynamicUrl, payload).pipe(map((response) => response));
    }
    saveQuestionStepList(taskId, stepId, companyId, payload) {
        let userType = localStorage.getItem('userTypeRole');
        if (userType === 'Beneficiary') {
            if (localStorage.getItem('cqCompanyId')) {
                companyId = localStorage.getItem('cqCompanyId');
            }
        }
        let dynamicUrl;
        dynamicUrl = `/saveCustomStepForTask/${taskId}/${stepId}/${companyId}`;
        return this.httpClient.post(dynamicUrl, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getSuperTask(superTaskId) {
        return this.httpClient.get(`/superTask/${superTaskId}/overview`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    saveCustomQuestionStep(taskId, stepId, payload) {
        let dynamicUrl;
        dynamicUrl = `/task/${taskId}/Step/${stepId}`;
        return this.httpClient.post(dynamicUrl, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getQuestionList(beneficiaryId, companyId, familyId) {
        let dynamicUrl;
        if (familyId) {
            dynamicUrl = `/getCustomSectionsForBeneficiary/${beneficiaryId}/${companyId}?familyId=${familyId}`;
        }
        else {
            dynamicUrl = `/getCustomSectionsForBeneficiary/${beneficiaryId}/${companyId}`;
        }
        return this.httpClient.get(dynamicUrl).pipe(map((response) => response.data));
    }
    getQuestionListSteps(companyId, taskTypeId) {
        let dynamicUrl;
        if (sessionStorage.getItem('isCaseRequest')) {
            dynamicUrl = `/getCustomQuestionnaryDetails/company/${companyId}?taskTypeId=${taskTypeId}&isUsedForCaseRequest=true`;
        }
        else {
            dynamicUrl = `/getCustomQuestionnaryDetails/company/${companyId}?taskTypeId=${taskTypeId}`;
        }
        return this.httpClient.get(dynamicUrl).pipe(map((response) => response.data));
    }
    getCustomStepForTask(taskId, stepId, companyId) {
        let dynamicUrl;
        dynamicUrl = `/getCustomStepForTask/${taskId}/${stepId}/${companyId}`;
        return this.httpClient.get(dynamicUrl).pipe(map((response) => response.data));
    }
}
CustomQuestionnaireService.ɵfac = function CustomQuestionnaireService_Factory(t) { return new (t || CustomQuestionnaireService)(i0.ɵɵinject(i1.HttpClient)); };
CustomQuestionnaireService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomQuestionnaireService, factory: CustomQuestionnaireService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomQuestionnaireService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function CustomQuestionnaireComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtext(2, " Loading... ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CustomQuestionnaireComponent_div_1_div_4_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function CustomQuestionnaireComponent_div_1_div_4_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(3); return ctx_r7.updateStepStatus("INPROGRESS"); });
    i0.ɵɵelementStart(1, "span", 16);
    i0.ɵɵelement(2, "img", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "Edit ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", (ctx_r6.stepDetails == null ? null : ctx_r6.stepDetails.stepStatusCode) === "NEW" || (ctx_r6.stepDetails == null ? null : ctx_r6.stepDetails.stepStatusCode) === "INPROGRESS");
} }
function CustomQuestionnaireComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵlistener("click", function CustomQuestionnaireComponent_div_1_div_4_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.toggleMaximize(); });
    i0.ɵɵelement(2, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CustomQuestionnaireComponent_div_1_div_4_button_3_Template, 4, 1, "button", 13);
    i0.ɵɵelementStart(4, "i", 14);
    i0.ɵɵlistener("click", function CustomQuestionnaireComponent_div_1_div_4_Template_i_click_4_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.closeModal(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.beneQuestIsCaseRequest !== "true");
} }
function CustomQuestionnaireComponent_div_1_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6", 21);
    i0.ɵɵlistener("click", function CustomQuestionnaireComponent_div_1_div_5_div_1_Template_h6_click_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(3); return ctx_r15.updateStepStatus("INPROGRESS"); });
    i0.ɵɵelementStart(2, "mat-icon", 22);
    i0.ɵɵtext(3, " play_circle_outline ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, " Do you wish to start now? ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CustomQuestionnaireComponent_div_1_div_5_div_2_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 25);
} }
const _c0 = function (a0, a1, a2) { return { "pending": a0, "overDue": a1, "completed": a2 }; };
function CustomQuestionnaireComponent_div_1_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h6", 23);
    i0.ɵɵtemplate(2, CustomQuestionnaireComponent_div_1_div_5_div_2_i_2_Template, 1, 0, "i", 24);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c0, (ctx_r13.stepDetails == null ? null : ctx_r13.stepDetails.completionStatus) === "PENDING", (ctx_r13.stepDetails == null ? null : ctx_r13.stepDetails.completionStatus) === "OVERDUE", (ctx_r13.stepDetails == null ? null : ctx_r13.stepDetails.completionStatus) === "COMPLETED"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.stepDetails.estimatedTime);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r13.stepDetails == null ? null : ctx_r13.stepDetails.estimatedTime);
} }
function CustomQuestionnaireComponent_div_1_div_5_div_3_h6_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Assign To : ", ctx_r18.stepDetails == null ? null : ctx_r18.stepDetails.assignToEmployeeName, " ");
} }
function CustomQuestionnaireComponent_div_1_div_5_div_3_h6_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6");
    i0.ɵɵelementStart(1, "b", 27);
    i0.ɵɵtext(2, "Assign To");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" : ", ctx_r19.assignBeneficiary, "");
} }
function CustomQuestionnaireComponent_div_1_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, CustomQuestionnaireComponent_div_1_div_5_div_3_h6_1_Template, 2, 1, "h6", 19);
    i0.ɵɵtemplate(2, CustomQuestionnaireComponent_div_1_div_5_div_3_h6_2_Template, 4, 1, "h6", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.stepDetails.isPetitionerAction === 1 || ctx_r14.stepDetails.isAttorneyAction === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.stepDetails.isBeneficiaryAction === 1);
} }
function CustomQuestionnaireComponent_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, CustomQuestionnaireComponent_div_1_div_5_div_1_Template, 6, 0, "div", 19);
    i0.ɵɵtemplate(2, CustomQuestionnaireComponent_div_1_div_5_div_2_Template, 6, 7, "div", 19);
    i0.ɵɵtemplate(3, CustomQuestionnaireComponent_div_1_div_5_div_3_Template, 3, 2, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r5.stepDetails == null ? null : ctx_r5.stepDetails.stepStatusCode) === "NEW");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r5.stepDetails == null ? null : ctx_r5.stepDetails.stepStatusCode) === "INPROGRESS" || (ctx_r5.stepDetails == null ? null : ctx_r5.stepDetails.stepStatusCode) === "SUBMIT" || (ctx_r5.stepDetails == null ? null : ctx_r5.stepDetails.stepStatusCode) === "COMPLETE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.stepDetails == null ? null : ctx_r5.stepDetails.assignToEmployeeName);
} }
function CustomQuestionnaireComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "header", 7);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomQuestionnaireComponent_div_1_div_4_Template, 5, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CustomQuestionnaireComponent_div_1_div_5_Template, 4, 3, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.stepDetails && (ctx_r1.stepDetails == null ? null : ctx_r1.stepDetails.stepName) && ctx_r1.isNewPortion ? ctx_r1.stepDetails.stepName : "Additional Details");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isNewPortion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.dialogData.isCustomStep && ctx_r1.beneQuestIsCaseRequest !== "true");
} }
function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵtext(2, " No Additional details are asked. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "label", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 39);
    i0.ɵɵelementStart(4, "input", 40);
    i0.ɵɵlistener("ngModelChange", function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_2_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r33); const item_r25 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(3); return (ctx_r32.customQues[item_r25 == null ? null : item_r25.questionId] = $event); })("click", function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_2_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r33); const _r31 = i0.ɵɵreference(7); return _r31.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "mat-datepicker-toggle", 41);
    i0.ɵɵelement(6, "mat-datepicker", null, 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r31 = i0.ɵɵreference(7);
    const item_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hidden", (item_r25 == null ? null : item_r25.isBenHidden) == 1 ? true : false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r25.questionLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r27.beneQuestIsCaseRequest !== "true" && ((item_r25 == null ? null : item_r25.isBenReadable) || (item_r25 == null ? null : item_r25.isReadOnly) || (ctx_r27.stepDetails == null ? null : ctx_r27.stepDetails.stepStatusCode) === "NEW" || (ctx_r27.stepDetails == null ? null : ctx_r27.stepDetails.stepStatusCode) == "COMPLETE"))("matDatepicker", _r31)("ngModel", ctx_r27.customQues[item_r25 == null ? null : item_r25.questionId]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r31);
} }
const _c1 = function () { return { width: "100%" }; };
function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "label", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "textarea", 45);
    i0.ɵɵlistener("ngModelChange", function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_3_Template_textarea_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r38); const item_r25 = i0.ɵɵnextContext().$implicit; const ctx_r37 = i0.ɵɵnextContext(3); return (ctx_r37.customQues[item_r25 == null ? null : item_r25.questionId] = $event); });
    i0.ɵɵtext(4, "                        ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hidden", (item_r25 == null ? null : item_r25.isBenHidden) == 1 ? true : false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r25.questionLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(7, _c1));
    i0.ɵɵproperty("rows", 3)("ngModel", ctx_r28.customQues[item_r25 == null ? null : item_r25.questionId])("disabled", ctx_r28.beneQuestIsCaseRequest !== "true" && ((item_r25 == null ? null : item_r25.isBenReadable) || (item_r25 == null ? null : item_r25.isReadOnly) || (ctx_r28.stepDetails == null ? null : ctx_r28.stepDetails.stepStatusCode) === "NEW" || (ctx_r28.stepDetails == null ? null : ctx_r28.stepDetails.stepStatusCode) == "COMPLETE"));
} }
function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelementStart(1, "label", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "input", 46);
    i0.ɵɵlistener("ngModelChange", function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_4_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r42); const item_r25 = i0.ɵɵnextContext().$implicit; const ctx_r41 = i0.ɵɵnextContext(3); return (ctx_r41.customQues[item_r25 == null ? null : item_r25.questionId] = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("hidden", (item_r25 == null ? null : item_r25.isBenHidden) == 1 ? true : false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r25.questionLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r29.customQues[item_r25 == null ? null : item_r25.questionId])("disabled", ctx_r29.beneQuestIsCaseRequest !== "true" && ((item_r25 == null ? null : item_r25.isBenReadable) || (item_r25 == null ? null : item_r25.isReadOnly) || (ctx_r29.stepDetails == null ? null : ctx_r29.stepDetails.stepStatusCode) === "NEW" || (ctx_r29.stepDetails == null ? null : ctx_r29.stepDetails.stepStatusCode) == "COMPLETE"));
} }
function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "mat-checkbox", 49);
    i0.ɵɵlistener("ngModelChange", function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_5_div_4_Template_mat_checkbox_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r49); const j_r47 = ctx.index; const item_r25 = i0.ɵɵnextContext(2).$implicit; const ctx_r48 = i0.ɵɵnextContext(3); return ctx_r48.customQues[item_r25 == null ? null : item_r25.questionId][j_r47].checked = $event; });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r46 = ctx.$implicit;
    const j_r47 = ctx.index;
    const ctx_r51 = i0.ɵɵnextContext(2);
    const i_r26 = ctx_r51.index;
    const item_r25 = ctx_r51.$implicit;
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("name", "opt", i_r26, "");
    i0.ɵɵproperty("ngModel", ctx_r45.customQues[item_r25 == null ? null : item_r25.questionId][j_r47].checked)("disabled", ctx_r45.beneQuestIsCaseRequest !== "true" && ((item_r25 == null ? null : item_r25.isBenReadable) || (item_r25 == null ? null : item_r25.isReadOnly) || (ctx_r45.stepDetails == null ? null : ctx_r45.stepDetails.stepStatusCode) === "NEW" || (ctx_r45.stepDetails == null ? null : ctx_r45.stepDetails.stepStatusCode) == "COMPLETE"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", opt_r46, " ");
} }
function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "label", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 47);
    i0.ɵɵtemplate(4, CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_5_div_4_Template, 3, 4, "div", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("hidden", (item_r25 == null ? null : item_r25.isBenHidden) == 1 ? true : false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r25.questionLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", (item_r25 == null ? null : item_r25.layOutJsonDTO == null ? null : item_r25.layOutJsonDTO.layOutVertical) == "1" ? "verticalCls" : "horizontalCls");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", item_r25.layOutJsonDTO.options);
} }
function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtemplate(2, CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_2_Template, 8, 6, "div", 35);
    i0.ɵɵtemplate(3, CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_3_Template, 5, 8, "div", 36);
    i0.ɵɵtemplate(4, CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_4_Template, 4, 4, "div", 35);
    i0.ɵɵtemplate(5, CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_div_5_Template, 5, 4, "div", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r25 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r25.answerTypeId === "DATE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r25.answerTypeId === "LONGANS");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r25.answerTypeId === "SHORTANS");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r25.answerTypeId === "MULTISELECT");
} }
function CustomQuestionnaireComponent_mat_dialog_content_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_1_Template, 3, 0, "div", 31);
    i0.ɵɵelementStart(2, "div", 32);
    i0.ɵɵtemplate(3, CustomQuestionnaireComponent_mat_dialog_content_2_div_1_div_3_Template, 6, 4, "div", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sdata_r21 = ctx.$implicit;
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", (sdata_r21 == null ? null : sdata_r21.isReadOnly) ? "disableCls col-md-12 p-0 customQuestions" : "col-md-12 p-0 customQuestions");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r20.listOfQuestions.length && ctx_r20.dialogData.isCustomStep);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", sdata_r21.questionList);
} }
function CustomQuestionnaireComponent_mat_dialog_content_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-dialog-content", 28);
    i0.ɵɵtemplate(1, CustomQuestionnaireComponent_mat_dialog_content_2_div_1_Template, 4, 3, "div", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.listOfQuestions);
} }
function CustomQuestionnaireComponent_mat_dialog_actions_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 56);
    i0.ɵɵlistener("click", function CustomQuestionnaireComponent_mat_dialog_actions_3_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r59); const ctx_r58 = i0.ɵɵnextContext(2); return ctx_r58.onClickSave(null); });
    i0.ɵɵtext(1, "Save");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sdata_r56 = ctx.$implicit;
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", (ctx_r53.stepDetails == null ? null : ctx_r53.stepDetails.stepStatusCode) == "COMPLETE" || ctx_r53.beneQuestIsCaseRequest !== "true" && ctx_r53.userType === "Attorney")("ngClass", ctx_r53.beneQuestIsCaseRequest == "true" ? (ctx_r53.stepDetails == null ? null : ctx_r53.stepDetails.isReadOnly) ? "disableCls" : "" : (sdata_r56 == null ? null : sdata_r56.isReadOnly) ? "disableCls" : "");
} }
function CustomQuestionnaireComponent_mat_dialog_actions_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 57);
    i0.ɵɵlistener("click", function CustomQuestionnaireComponent_mat_dialog_actions_3_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r61); const ctx_r60 = i0.ɵɵnextContext(2); ctx_r60.onClickSave(null); return ctx_r60.updateStepStatus("COMPLETE"); });
    i0.ɵɵtext(1, "Mark Complete");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", (ctx_r54.stepDetails == null ? null : ctx_r54.stepDetails.isReadOnly) || (ctx_r54.stepDetails == null ? null : ctx_r54.stepDetails.stepStatusCode) == "NEW" ? "disableCls" : "");
} }
function CustomQuestionnaireComponent_mat_dialog_actions_3_div_4_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 60);
} }
function CustomQuestionnaireComponent_mat_dialog_actions_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵtemplate(1, CustomQuestionnaireComponent_mat_dialog_actions_3_div_4_img_1_Template, 1, 0, "img", 59);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r55.stepDetails == null ? null : ctx_r55.stepDetails.stepStatusCode) === "COMPLETE");
} }
function CustomQuestionnaireComponent_mat_dialog_actions_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-dialog-actions", 50);
    i0.ɵɵelementStart(1, "div", 51);
    i0.ɵɵtemplate(2, CustomQuestionnaireComponent_mat_dialog_actions_3_button_2_Template, 2, 2, "button", 52);
    i0.ɵɵtemplate(3, CustomQuestionnaireComponent_mat_dialog_actions_3_button_3_Template, 2, 1, "button", 53);
    i0.ɵɵtemplate(4, CustomQuestionnaireComponent_mat_dialog_actions_3_div_4_Template, 2, 1, "div", 54);
    i0.ɵɵelement(5, "lib-step-status-update-component-library", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.listOfQuestions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r3.stepDetails == null ? null : ctx_r3.stepDetails.stepStatusCode) !== "COMPLETE" && ctx_r3.beneQuestIsCaseRequest !== "true");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r3.stepDetails == null ? null : ctx_r3.stepDetails.completionStatus) === "COMPLETED" || (ctx_r3.stepDetails == null ? null : ctx_r3.stepDetails.stepStatusCode) === "COMPLETE");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", (ctx_r3.primaryData == null ? null : ctx_r3.primaryData.caseType) != "I130" ? ctx_r3.primaryData == null ? null : ctx_r3.primaryData.visatype : ctx_r3.primaryData == null ? null : ctx_r3.primaryData.caseType)("stepDetails", ctx_r3.stepDetails)("type", "NONE")("isViewMode", true)("showPreviousStepBtn", ctx_r3.showPrev)("showNextStepBtn", ctx_r3.showNext);
} }
class CustomQuestionnaireComponent {
    constructor(stepStatusUpdatePayloadCostruction, elementRef, customQuestionsService, dialogRef, dialogData, toastr, store, apiService) {
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.elementRef = elementRef;
        this.customQuestionsService = customQuestionsService;
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.toastr = toastr;
        this.store = store;
        this.apiService = apiService;
        this.customQues = {};
        this.questionStatus = false;
        this.showNext = false;
        this.showPrev = false;
        this.observableSubscription$ = new Subject();
        this.onDialogClose = new EventEmitter();
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.init();
        this.store.pipe(select(getStepStatusUpdate))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                this.init();
            }
        });
    }
    init() {
        this.beneQuestIsCaseRequest = 'beneQuestIsCaseRequest' in sessionStorage ? sessionStorage.getItem('beneQuestIsCaseRequest') : 'false';
        this.isCaseRequest = 'isCaseRequest' in sessionStorage && sessionStorage.getItem('isCaseRequest') ? 'true' : 'false';
        if (sessionStorage.getItem('taskID')) {
            this.apiService.getSuperTask(sessionStorage.getItem('taskID')).pipe(takeUntil(this.destroy$)).subscribe((data) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                this.isSectionStatus = this.isSection;
                this.isNewPortionVisible = this.isNewPortion;
                this.currentLoadedIn = this.loadedIn;
                this.taskId = this.taskId ? this.taskId : this.dialogData.taskId;
                this.overviewSteps = data;
                this.showNext = (_a = this.dialogData) === null || _a === void 0 ? void 0 : _a.showNext;
                this.showPrev = (_b = this.dialogData) === null || _b === void 0 ? void 0 : _b.showPrev;
                if (this.dialogData.isCustomStep) {
                    // this.customStepOverviewList = data.subTaskList.find(t => t.id === this.taskId).customStepOverviewList.find(s => s.stepName == this.dialogData.stepName && s.stepId == this.dialogData.stepId ? this.dialogData.stepId : this.stepId);
                    this.customStepOverviewList = (_f = (_e = (_d = (_c = data.subTaskList) === null || _c === void 0 ? void 0 : _c.find(t => t.id === this.taskId)) === null || _d === void 0 ? void 0 : _d.customStepOverviewList) === null || _e === void 0 ? void 0 : _e.find(s => s.stepName === this.dialogData.stepName && s.stepId === this.dialogData.stepId)) !== null && _f !== void 0 ? _f : [];
                }
                else {
                    this.customStepOverviewList = (_k = (_j = (_h = (_g = data.subTaskList) === null || _g === void 0 ? void 0 : _g.find(t => t.id === this.taskId)) === null || _h === void 0 ? void 0 : _h.stepOverviewList) === null || _j === void 0 ? void 0 : _j.find(s => s.stepName === this.dialogData.stepName && s.stepId === this.dialogData.stepId)) !== null && _k !== void 0 ? _k : [];
                    // this.customStepOverviewList = data.subTaskList.find(t => t.id === this.taskId).stepOverviewList.find(s => s.stepName == this.dialogData.stepName && s.stepId == this.dialogData.stepId ? this.dialogData.stepId : this.stepId);
                }
                if (sessionStorage.getItem('companyId')) {
                    this.currentCompanyId = parseInt(sessionStorage.getItem('companyId'));
                }
                else {
                    let custCompanyId = JSON.parse(localStorage.getItem('custCompanyId'));
                    let custBeneficiaryId = JSON.parse(localStorage.getItem('custBeneficiaryId'));
                    this.currentCompanyId = custCompanyId;
                    this.currentBeneficiaryId = custBeneficiaryId ? custBeneficiaryId : this.beneficiaryId;
                }
                this.onLoadPage();
                setTimeout(() => {
                    // let form = this.elementRef.nativeElement.parentElement;
                    let form = this.elementRef.nativeElement.closest('form');
                    if (form) {
                        form.addEventListener('submit', this.onClick.bind(this));
                    }
                    else {
                        this.showSaveBtn = true;
                    }
                    ;
                }, 3000);
            });
        }
    }
    // ngAfterViewInit() {
    //   this.elementRef.nativeElement.querySelector('form')
    //                                 .addEventListener('submit', this.onClick.bind(this));
    // }
    onClick(event) {
        this.onClickSave(null);
    }
    closeModal() {
        this.dialogRef.close();
    }
    toggleMaximize() {
    }
    ngOnChanges(event) {
        var _a;
        // console.log('this.isFamilyIdevent11', event);
        if (event.loadedIn && event.loadedIn.currentValue) {
            this.currentLoadedIn = event.loadedIn.currentValue;
        }
        if (event.beneficiaryId && event.beneficiaryId.currentValue) {
            this.currentBeneficiaryId = event.beneficiaryId.currentValue;
        }
        if (event.viewQuestions && event.viewQuestions.currentValue) {
            this.isViewQuestions = event.viewQuestions.currentValue;
        }
        if (event.isNewPortion && event.isNewPortion.currentValue) {
            this.isNewPortionVisible = event.isNewPortion.currentValue;
        }
        if (event.isSection && event.isSection.currentValue) {
            this.isSectionStatus = event.isSection.currentValue;
        }
        if ((event.familyId && event.familyId.currentValue) && (event.familyId.currentValue !== event.familyId.previousValue)) {
            this.isFamilyId = event.familyId.currentValue;
            this.onLoadPage();
        }
        if ((_a = event.isCustomTriggered) === null || _a === void 0 ? void 0 : _a.currentValue) {
            this.onClickSave(null);
        }
    }
    onLoadPage() {
        // this.loadStepDetails();
        // After the api call below response will get
        this.loading = true;
        let tasktypeID = parseInt(sessionStorage.getItem('taskTypeId'));
        let companyId = parseInt(sessionStorage.getItem('companyId'));
        this.userType = localStorage.getItem('userTypeRole');
        if (this.userType === 'Beneficiary') {
            companyId = parseInt(localStorage.getItem('cqCompanyId'));
        }
        if (!isNaN(tasktypeID) && !isNaN(companyId)) {
            this.customQuestionsService.getQuestionListSteps(companyId, tasktypeID).subscribe((masterRes) => {
                const masterData = masterRes;
                if (this.dialogData.isCustomStep) {
                    this.masterstep = this.masterstep ? this.masterstep : masterRes.customStepList.find(x => x.stepName == this.loadedIn && x.id === (this.dialogData.stepId ? this.dialogData.stepId : this.stepId));
                }
                else {
                    const userType = this.userType;
                    const isAttorneyAction = userType === 'Attorney' || userType === 'Petitioner';
                    this.masterstep = masterRes.stepList.find(x => x.stepName === this.loadedIn && (isAttorneyAction ? x.isAttorneyAction : x.isBeneficiaryAction));
                }
                let res = { stepList: this.overviewSteps.subTaskList[0].stepOverviewList, customStepList: this.overviewSteps.subTaskList[0].customStepOverviewList };
                if (res.stepList.length && this.masterstep) {
                    this.loading = false;
                    let step = res.stepList.find(x => x.stepName == this.loadedIn && x.id === (this.dialogData.stepId ? this.dialogData.stepId : this.stepId));
                    step = step ? step : res.customStepList.find(x => x.stepName == this.loadedIn && x.stepId === (this.dialogData.stepId ? this.dialogData.stepId : this.stepId));
                    step.questionList = this.masterstep.questionList;
                    step.stepId = step.stepId ? step.stepId : this.masterstep.id;
                    this.stepDetails = step;
                    try {
                        this.customQuestionsService.getCustomStepForTask(this.taskId, this.dialogData.stepId ? this.dialogData.stepId : this.masterstep.id, companyId).subscribe((data) => {
                            var _a;
                            this.loading = false;
                            if (data) {
                                data.customStepList.length > 0 ? this.answeredBefore = true : this.answeredBefore = false;
                                let actualQuestions = step.questionList.map(x => x.questionId);
                                let answeredQuestionStep = data.customStepList.find(x => x.stepName == this.loadedIn);
                                if (this.dialogData.isCustomStep) {
                                    answeredQuestionStep = answeredQuestionStep ? answeredQuestionStep : data.customStepList.find(x => x.stepName == this.loadedIn && x.id === this.stepDetails.id ? this.stepDetails.id : this.stepDetails.stepId);
                                }
                                else {
                                    answeredQuestionStep = answeredQuestionStep ? answeredQuestionStep : data.stepList.find(x => x.stepName == this.loadedIn && x.id === this.stepDetails.id ? this.stepDetails.id : this.stepDetails.stepId);
                                }
                                this.stepDetails.questionList = answeredQuestionStep.questionList;
                                answeredQuestionStep.stepStatusCode = (_a = this.stepDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                                answeredQuestionStep.stepStatusName = this.stepDetails.stepStatusName;
                                let answeredQuestions = answeredQuestionStep.questionList.map(x => x.questionId);
                                if (actualQuestions.filter(element => answeredQuestions.includes(element)).length > 0) {
                                    data.customStepOverviewList = data.customStepList;
                                    data.stepOverviewList = data.stepList;
                                    this.parseGetStepData(data);
                                }
                                else {
                                    this.parseGetStepData(masterData);
                                }
                            }
                            else {
                                this.parseGetStepData(masterData);
                            }
                        });
                    }
                    catch (error) {
                        this.parseGetStepData(masterData);
                    }
                }
                else {
                    this.loading = false;
                    this.parseGetStepData(masterData);
                }
            });
        }
    }
    parseGetStepData(data) {
        if (data) {
            setTimeout(() => {
                this.dataResponse = data;
                if (!this.isNewPortionVisible) {
                    this.conditionalShowItems(1);
                }
                else {
                    this.conditionalShowItems(2);
                }
            }, 100);
        }
    }
    conditionalShowItems(data) {
        this.listOfQuestions = [];
        if (data == 1) {
            if (this.dataResponse.stepList.length !== 0) {
                this.conditionalFilter(this.dataResponse.stepList, data);
            }
        }
        else if (data == 2) {
            if (this.dataResponse.customStepList.length !== 0) {
                this.conditionalFilter(this.dataResponse.customStepList, data);
            }
        }
    }
    conditionalFilter(resData, data) {
        var _a;
        let stepQuestions = this.stepDetails;
        // let stepQuestions = data == 1 ? this.stepDetails : (this.answeredBefore?resData:this.masterstep);
        // if(this.dialogData.isCustomStep){
        //   stepQuestions = resData.find(d=>d.id === this.stepDetails.id);
        // }else{
        //   stepQuestions = resData.find(d=>d.stepId === this.masterstep.id);
        // }
        if (stepQuestions && stepQuestions.questionList && stepQuestions.questionList.length && !this.answeredBefore) {
            this.listOfQuestions = [stepQuestions];
            this.stepId = this.listOfQuestions[0].id;
        }
        else if (stepQuestions && this.answeredBefore) {
            this.listOfQuestions = [stepQuestions];
            this.stepId = this.listOfQuestions[0].id;
        }
        else {
            this.listOfQuestions = [];
        }
        // console.log("list of questions ::", this.listOfQuestions)
        if (this.listOfQuestions && ((_a = this.listOfQuestions) === null || _a === void 0 ? void 0 : _a.length) !== 0) {
            this.questionStatus = true;
            // console.log("list of questions ::", this.listOfQuestions)
            stepQuestions.questionList.forEach((item, i) => {
                this.generateQuestions(item);
            });
        }
        else {
            this.questionStatus = false;
        }
    }
    generateQuestions(item) {
        // console.log('itemmmmmmmm', item);
        // console.log("generateQuestions list of questions ::", this.listOfQuestions)
        if (item.answerTypeId == 'MULTISELECT') {
            this.customQues[item.questionId] = [];
            item.layOutJsonDTO.options.forEach((data, k) => {
                this.customQues[item.questionId].push({
                    checked: false
                });
            });
            if (item.multiSelectAnswers) {
                item.layOutJsonDTO.options.forEach((data, j) => {
                    item.multiSelectAnswers.forEach((res, n) => {
                        if (data == res) {
                            this.customQues[item.questionId][j].checked = true;
                        }
                    });
                });
            }
        }
        else {
            this.customQues[item.questionId] = item.answers;
        }
    }
    onClickSave(data) {
        if (this.mapQuestions()) {
            // let companyId: any = this.dialogData.subTaskDetails.createdByUserType=== "Attorney"?this.dialogData.subTaskDetails.attorneyId:this.dialogData.subTaskDetails.companyId; parseInt(sessionStorage.getItem('companyId'));
            // let companyId: any =  parseInt(sessionStorage.getItem('companyId'));
            let userType = localStorage.getItem('userTypeRole');
            if (userType === 'Beneficiary') {
                this.currentCompanyId = parseInt(localStorage.getItem('cqCompanyId'));
            }
            let reqObj = {
                customSectionList: [],
                customStepList: this.dataResponse.customStepList,
                sectionList: [],
                stepList: this.dataResponse.stepList,
            };
            this.customQuestionsService.saveQuestionStepList(this.taskId, this.stepDetails.stepId, this.currentCompanyId, reqObj).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                if (data) {
                    this.toastr.success(data.message, 'Success');
                }
            });
        }
    }
    mapQuestions() {
        let mapQuesData;
        if (!this.isNewPortionVisible) {
            // console.log('this.dataResponse.stepList', this.dataResponse)
            mapQuesData = this.mapQuestionnaire(this.dataResponse.stepList);
        }
        else {
            // console.log('this.dataResponse.customStepList', this.dataResponse.customStepList)
            mapQuesData = this.mapQuestionnaire(this.dataResponse.customStepList);
        }
        return mapQuesData;
    }
    mapQuestionnaire(resData) {
        for (const [key, value] of Object.entries(this.customQues)) {
            let tempQuesVal = value;
            resData.find(b => b.id === this.stepDetails.stepId).questionList.forEach((item, i) => {
                // this.stepDetails.questionList.forEach((item: any, i) => {
                if (item.questionId == key) {
                    if (item.answerTypeId == "MULTISELECT") {
                        let tempMultiAns = [];
                        item.layOutJsonDTO.options.forEach((val, j) => {
                            tempQuesVal.forEach((res, k) => {
                                if (res.checked && j == k) {
                                    tempMultiAns.push(val);
                                }
                            });
                        });
                        item.multiSelectAnswers = tempMultiAns;
                    }
                    else {
                        item.answers = value;
                    }
                }
            });
        }
        return this.dataResponse;
    }
    updateStepStatus(status) {
        // console.log('status custom questionanaire component', status);
        // console.log('this.stepId', this.stepId);
        // console.log('this.taskId', this.taskId);
        if (status && this.customStepOverviewList.id && this.taskId) {
            let data = {
                statusCode: status,
                "benchMarkActionCode": "",
                "endDate": "",
                "isAttorneyNotify": 0,
                "isBeneficiaryNotify": 0,
                "isPetitionerNotify": 0,
                "receiptCategory": "",
                "receiptDate": "",
                "receiptNumber": "",
                "receiptType": "",
                "responseCode": null,
                "responseNote": "",
                "reviewCode": null,
                "reviewNote": null,
                "startDate": "",
                "stepNote": ""
            };
            this.customQuestionsService.saveCustomQuestionStep(this.taskId, this.stepDetails.id, data).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                if (data) {
                    // console.log('resdata', data);
                    if (data.message !== '')
                        this.toastr.success(data.message, 'Success');
                    this.init();
                }
            });
        }
        // this.store.dispatch(updateStepStatus({
        //   payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
        //   subTaskId: this.stepDetails.taskId,
        //   visaType: this.inputData.caseType === 'I130' ?
        //     this.inputData.caseType : this.inputData.visatype,
        //   stepId: this.inputData.stepId
        // }));
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
}
CustomQuestionnaireComponent.ɵfac = function CustomQuestionnaireComponent_Factory(t) { return new (t || CustomQuestionnaireComponent)(i0.ɵɵdirectiveInject(i1$1.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(CustomQuestionnaireService), i0.ɵɵdirectiveInject(i3.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i5.Store), i0.ɵɵdirectiveInject(i6.APIDocumentChecklist)); };
CustomQuestionnaireComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomQuestionnaireComponent, selectors: [["lib-custom-questionnaire"]], inputs: { loadedIn: "loadedIn", beneficiaryId: "beneficiaryId", viewQuestions: "viewQuestions", isNewPortion: "isNewPortion", isCustomTriggered: "isCustomTriggered", isSection: "isSection", familyId: "familyId", taskId: "taskId", showSaveBtn: "showSaveBtn", stepId: "stepId", subTaskDetails: "subTaskDetails", primaryData: "primaryData", isViewMode: "isViewMode" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 4, consts: [["class", "row customQuestionPortion", 4, "ngIf"], ["mat-dialog-title", "", "class", "d-flex flex-column justify-content-between align-items-center mat-dialog-title-cq", 4, "ngIf"], ["class", "row customQuestionPortion mat-dialog-content-cq", 4, "ngIf"], ["align", "end", "class", "mat-dialog-actions-cq", 4, "ngIf"], [1, "row", "customQuestionPortion"], [1, "col-md-12"], ["mat-dialog-title", "", 1, "d-flex", "flex-column", "justify-content-between", "align-items-center", "mat-dialog-title-cq"], [1, "w-100", "d-flex", "flex-row", "justify-content-between", "align-items-center", "mb-2"], ["class", "d-flex align-items-center align-self-start", 4, "ngIf"], ["class", "w-100 d-flex flex-row justify-content-between align-items-center startTime", 4, "ngIf"], [1, "d-flex", "align-items-center", "align-self-start"], [1, "p-dialog-header-maximize-icon", "pr-1", 3, "click"], [1, "pi", "p-maximize"], ["type", "button", "style", " height: 28px; margin-right: 10px; padding: 5px !important; font-size: 14px;", "class", "im-btn-with-icon im-btn-outline-primary d-flex align-items-center button_whitebg edit", 3, "disabled", "click", 4, "ngIf"], [1, "pointer", "close-icon", "pi", "pi-times", 3, "click"], ["type", "button", 1, "im-btn-with-icon", "im-btn-outline-primary", "d-flex", "align-items-center", "button_whitebg", "edit", 2, "height", "28px", "margin-right", "10px", "padding", "5px !important", "font-size", "14px", 3, "disabled", "click"], ["tooltipPosition", "bottom", 1, "mr-2", "d-flex", "align-items-center"], ["src", "../../../../../assets/images/edit.png"], [1, "w-100", "d-flex", "flex-row", "justify-content-between", "align-items-center", "startTime"], [4, "ngIf"], ["class", "p-0 col-md-6 text-right assignTo pull", 4, "ngIf"], [1, "d-flex", "align-items-center", 3, "click"], [1, "icon", "pr-2"], [1, "d-flex", "align-items-center", 3, "ngClass"], ["class", "pi pi-clock icons", 4, "ngIf"], [1, "pi", "pi-clock", "icons"], [1, "p-0", "col-md-6", "text-right", "assignTo", "pull"], [2, "color", "#b1b1b1"], [1, "row", "customQuestionPortion", "mat-dialog-content-cq"], ["class", "col-md-12 p-0 customQuestions", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "col-md-12", "p-0", "customQuestions", 3, "ngClass"], ["class", "row", 4, "ngIf"], [1, "row"], ["class", "col-md-12", 4, "ngFor", "ngForOf"], [1, "col-md-12", "p-0"], ["class", "col-md-12 mb-2 p-0", 3, "hidden", 4, "ngIf"], ["class", "col-md-12 p-0", 3, "hidden", 4, "ngIf"], [1, "col-md-12", "mb-2", "p-0", 3, "hidden"], [1, "label-cls", "customWidth"], ["appearance", "outline", 1, "mt-0", "date-field", "customWidth"], ["matInput", "", "name", "startDate", "placeholder", "Date", 3, "disabled", "matDatepicker", "ngModel", "ngModelChange", "click"], ["matSuffix", "", 3, "for"], ["employedFromPicker", ""], [1, "col-md-12", "p-0", 3, "hidden"], [1, "label-cls"], ["pInputTextarea", "", "name", "question", "placeholder", "Enter answer", 3, "rows", "ngModel", "disabled", "ngModelChange"], ["pInputText", "", "placeholder", "Enter answer", "type", "text", 3, "ngModel", "disabled", "ngModelChange"], [3, "ngClass"], [4, "ngFor", "ngForOf"], [3, "ngModel", "name", "disabled", "ngModelChange"], ["align", "end", 1, "mat-dialog-actions-cq"], [1, "col-12", "d-flex", "align-items-center", "justify-content-end", "p-3"], ["class", "btn btn-primary", "type", "button", 3, "hidden", "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "im-btn im-btn-with-icon im-btn-outline-primary btn-small d-flex align-items-center button_whitebg stepCompleted ml-2", "type", "button", 3, "ngClass", "click", 4, "ngIf"], ["class", "stepCompleted", 4, "ngIf"], [1, "d-flex", "justify-content-end", 3, "visaType", "stepDetails", "type", "isViewMode", "showPreviousStepBtn", "showNextStepBtn"], ["type", "button", 1, "btn", "btn-primary", 3, "hidden", "ngClass", "click"], ["type", "button", 1, "im-btn", "im-btn-with-icon", "im-btn-outline-primary", "btn-small", "d-flex", "align-items-center", "button_whitebg", "stepCompleted", "ml-2", 3, "ngClass", "click"], [1, "stepCompleted"], ["src", "../../../../../assets/images/stepCompleteLabel.png", "alt", "Step Complete", 4, "ngIf"], ["src", "../../../../../assets/images/stepCompleteLabel.png", "alt", "Step Complete"]], template: function CustomQuestionnaireComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CustomQuestionnaireComponent_div_0_Template, 3, 0, "div", 0);
        i0.ɵɵtemplate(1, CustomQuestionnaireComponent_div_1_Template, 6, 3, "div", 1);
        i0.ɵɵtemplate(2, CustomQuestionnaireComponent_mat_dialog_content_2_Template, 2, 1, "mat-dialog-content", 2);
        i0.ɵɵtemplate(3, CustomQuestionnaireComponent_mat_dialog_actions_3_Template, 6, 9, "mat-dialog-actions", 3);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewQuestions && !ctx.loading && ctx.stepDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewQuestions && !ctx.loading && ctx.stepDetails && (ctx.listOfQuestions == null ? null : ctx.listOfQuestions.length));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSaveBtn && !ctx.loading && ctx.dialogData.isCustomStep);
    } }, directives: [i7.NgIf, i3.MatDialogTitle, i8.MatIcon, i7.NgClass, i3.MatDialogContent, i7.NgForOf, i9.MatFormField, i10.MatInput, i11.MatDatepickerInput, i12.DefaultValueAccessor, i12.NgControlStatus, i12.NgModel, i11.MatDatepickerToggle, i9.MatSuffix, i11.MatDatepicker, i13.InputTextarea, i14.InputText, i15.MatCheckbox, i3.MatDialogActions, i16.StepStatusUpdateComponentLibraryComponent], styles: [".verticalCls[_ngcontent-%COMP%]{display:grid}.horizontalCls[_ngcontent-%COMP%]{display:flex;gap:15px}.customQuestions[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{padding-bottom:5px;color:#1e1e1e}.customQuestions[_ngcontent-%COMP%]   .label-light[_ngcontent-%COMP%], .customQuestions[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{text-transform:capitalize}.customQuestionPortion[_ngcontent-%COMP%]{max-height:500px;overflow-y:auto}.customWidth[_ngcontent-%COMP%]{width:100%}.disableCls[_ngcontent-%COMP%]{pointer-events:none;opacity:.7}.startTime[_ngcontent-bbb-c761][_ngcontent-%COMP%]   h6[_ngcontent-bbb-c761][_ngcontent-%COMP%]{font-weight:500}.startTime[_ngcontent-bbb-c761][_ngcontent-%COMP%]   h6[_ngcontent-bbb-c761][_ngcontent-%COMP%]   .icon[_ngcontent-bbb-c761][_ngcontent-%COMP%]{font-size:35px;padding-right:10px;margin-right:20px;cursor:pointer}.startTime[_ngcontent-bbb-c761][_ngcontent-%COMP%]   h6[_ngcontent-bbb-c761][_ngcontent-%COMP%]   .icons[_ngcontent-bbb-c761][_ngcontent-%COMP%]{font-size:27px;font-weight:600;margin-right:12px;margin-left:5px}.startTime[_ngcontent-bbb-c761][_ngcontent-%COMP%]   h6[_ngcontent-bbb-c761][_ngcontent-%COMP%]   .span[_ngcontent-bbb-c761][_ngcontent-%COMP%]{padding-top:10px}.assignTo[_ngcontent-bbb-c761][_ngcontent-%COMP%]{text-align:right}.assignTo[_ngcontent-bbb-c761][_ngcontent-%COMP%]   h6[_ngcontent-bbb-c761][_ngcontent-%COMP%]{margin-bottom:0}.overDue[_ngcontent-bbb-c761][_ngcontent-%COMP%]{color:#980112}.completed[_ngcontent-bbb-c761][_ngcontent-%COMP%]{color:#4ec97a}.pending[_ngcontent-bbb-c761][_ngcontent-%COMP%]{color:#50a1da}[_nghost-%COMP%]{height:100%;display:flex;flex-flow:column}[_nghost-%COMP%]   .mat-dialog-content-cq[_ngcontent-%COMP%]{flex-grow:1;max-height:unset;padding:20px 0;margin:0;border-top:1px solid #eee}[_nghost-%COMP%]   .mat-dialog-title-cq[_ngcontent-%COMP%]{max-height:112px;padding:20px;background:#f5f5f5;margin-bottom:0}[_nghost-%COMP%]   .close-icon[_ngcontent-%COMP%]{background-color:#000;color:#fff;border-radius:100%;padding:5px;font-size:12px}[_nghost-%COMP%]   .mat-dialog-actions-cq[_ngcontent-%COMP%]{width:100%;margin:0;border-top:1px solid #eee;background:#f5f5f5}[_nghost-%COMP%]   .startTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font-weight:500}[_nghost-%COMP%]   .startTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{font-size:35px;padding-right:10px;margin-right:20px;cursor:pointer;width:35px;height:35px}[_nghost-%COMP%]   .startTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   .icons[_ngcontent-%COMP%]{font-size:27px;font-weight:600;margin-right:12px;margin-left:5px}[_nghost-%COMP%]   .startTime[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]   .span[_ngcontent-%COMP%]{padding-top:10px}[_nghost-%COMP%]   .assignTo[_ngcontent-%COMP%]{text-align:right}[_nghost-%COMP%]   .assignTo[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{margin-bottom:0}[_nghost-%COMP%]   .overDue[_ngcontent-%COMP%]{color:#980112}[_nghost-%COMP%]   .completed[_ngcontent-%COMP%]{color:#4ec97a}[_nghost-%COMP%]   .pending[_ngcontent-%COMP%]{color:#50a1da}.disabledView[_ngcontent-%COMP%]{pointer-events:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomQuestionnaireComponent, [{
        type: Component,
        args: [{
                selector: 'lib-custom-questionnaire',
                templateUrl: './custom-questionnaire.component.html',
                styleUrls: ['./custom-questionnaire.component.scss']
            }]
    }], function () { return [{ type: i1$1.StepStatusUpdatePayloadService }, { type: i0.ElementRef }, { type: CustomQuestionnaireService }, { type: i3.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i4.ToastrService }, { type: i5.Store }, { type: i6.APIDocumentChecklist }]; }, { loadedIn: [{
            type: Input
        }], beneficiaryId: [{
            type: Input
        }], viewQuestions: [{
            type: Input
        }], isNewPortion: [{
            type: Input
        }], isCustomTriggered: [{
            type: Input
        }], isSection: [{
            type: Input
        }], familyId: [{
            type: Input
        }], taskId: [{
            type: Input
        }], showSaveBtn: [{
            type: Input
        }], stepId: [{
            type: Input
        }], subTaskDetails: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], isViewMode: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class CustomQuestionnaireModule {
}
CustomQuestionnaireModule.ɵfac = function CustomQuestionnaireModule_Factory(t) { return new (t || CustomQuestionnaireModule)(); };
CustomQuestionnaireModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomQuestionnaireModule });
CustomQuestionnaireModule.ɵinj = i0.ɵɵdefineInjector({ providers: [
        DatePipe,
    ], imports: [[
            CommonModule,
            MatFormFieldModule,
            MatDatepickerModule,
            MatButtonToggleModule,
            MatCheckboxModule,
            MatDialogModule,
            FormsModule,
            MatInputModule,
            InputTextareaModule,
            MaximizeDialogLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            AssigningTaskLibraryModule,
            PrimengLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomQuestionnaireModule, { declarations: [CustomQuestionnaireComponent], imports: [CommonModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatDialogModule,
        FormsModule,
        MatInputModule,
        InputTextareaModule,
        MaximizeDialogLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        AssigningTaskLibraryModule,
        PrimengLibraryModule], exports: [CustomQuestionnaireComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomQuestionnaireModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CustomQuestionnaireComponent
                ],
                imports: [
                    CommonModule,
                    MatFormFieldModule,
                    MatDatepickerModule,
                    MatButtonToggleModule,
                    MatCheckboxModule,
                    MatDialogModule,
                    FormsModule,
                    MatInputModule,
                    InputTextareaModule,
                    MaximizeDialogLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    AssigningTaskLibraryModule,
                    PrimengLibraryModule,
                ],
                exports: [
                    CustomQuestionnaireComponent
                ],
                providers: [
                    DatePipe,
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-questionnaire
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomQuestionnaireComponent, CustomQuestionnaireModule, CustomQuestionnaireService };
//# sourceMappingURL=custom-questionnaire.js.map
